(function () {
    'use strict';
    angular
        .module('app.home')
        .directive('sc3FavoriteCoursesItem', sc3FavoriteCoursesItem);

    var noop = angular.noop,
        extend = angular.extend;

    sc3FavoriteCoursesItem.$inject = ['Member', 'Course', 'alert', 'confirm', 'home_resources'];
    function sc3FavoriteCoursesItem(Member, Course, alert, confirm, resources) {
        return {
            require: ['^^sc3FavoriteCourses', 'sc3FavoriteCoursesItem', 'form'],
            restrict: 'A',
            templateUrl: 'app/home/favorite-courses/favorite-courses-item.directive.html',
            scope: {
                course: '<sc3FavoriteCoursesItem'
            },
            link: link,
            controller: FavoriteCoursesItemController,
            controllerAs: '$ctrl',
            bindToController: true
        };

        function link(scope, element, attr, ctrls) {
            var sc3FavoriteCourses = ctrls[0],
                sc3FavoriteCoursesItem = ctrls[1],
                form = ctrls[2];

            sc3FavoriteCoursesItem.init(sc3FavoriteCourses, form, element);
        }

        function FavoriteCoursesItemController() {
            // Variables
            var ctrl = this, parent, element, searchPromise;

            // Methods
            ctrl.init = init;
            ctrl.search = search;
            ctrl.onSelect = onSelect;
            ctrl.onBlur = onBlur;

            ctrl.remove = remove;
            ctrl.cancel = cancel;
            ctrl.save = save;
            //////////////////

            function init(parentComponent, form, elem) {
                parent = parentComponent;
                ctrl.form = form;
                element = elem;
            }
            function search(text) {
                if (searchPromise)
                    searchPromise.$cancelRequest();
                searchPromise = Course.search({ text: text, $top: 10 });
                return searchPromise.$promise;
            }
            function onSelect($item) {
                extend(ctrl.course, $item);
            }
            function onBlur() {
                if (!ctrl.course.id) 
                    ctrl.onSelect({ name: null, city: null, region: null});
            }

            function remove() {
                confirm(resources.confirmRemoveCourseListItem, ctrl.course.name).then(remove, noop);

                function remove() {
                    Member.removeFromCourseList({ id: parent.individualId }, ctrl.course, success, error, true);

                    function success() {
                        parent.remove(ctrl.course);
                    }
                    function error() {
                        alert.error(resources.removeFromCourseListFailed, ctrl.course.name);
                    }
                }
            }
            function cancel() {
                if (ctrl.course.$new)
                    parent.remove(ctrl.course);
            }
            function save() {
                if (ctrl.form.$valid) {
                    Member.addToCourseList({ id: parent.individualId }, ctrl.course, success, error, true);
                }
                function success() {
                    delete ctrl.course.$new;
                }
                function error() {
                    alert.error(resources.addToCourseListFailed, ctrl.course.name);
                }
            }
        }
    }
})();
